/* eslint-disable camelcase */
export default {
  operation: "Operation",
  date: "Date",
  amount: "Amount",
  operation_history_for: "Operation history for {n1}",
  loading: 'loading...',
  operation_type_filter: "Filter by operation type",
  wallet_filter: "Wallet filter",

  op_online_fill_up: "Online Fill-Up",
  op_adjustment: "Adjustment",
  op_commission_payment: "Commission Payment",
  op_payout: "Withdrawal",
  op_account_to_account_transfer: "Account-to-Account Transfer",
  op_account_to_account_transfer_in: "Incoming Account-to-Account Transfer",
  op_account_to_account_transfer_out: "Outgoing Account-to-Account Transfer",
  op_administrative_transfer: "Administrative Transfer",
  op_administrative_transfer_in: "Incoming Administrative Transfer",
  op_administrative_transfer_out: "Outgoing Administrative Transfer",
  op_purchase_order: "Purchase Order",
  op_purchase_cancellation: "Purchase Cancellation",
  op_wallet_exchange: "Wallet Exchange",
  op_wallet_exchange_in: "Incoming Wallet Exchange",
  op_wallet_exchange_out: "Outgoing Wallet Exchange",
  op_undefined_operation: "Undefined Operation",
};
